"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum;
(function (TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum) {
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["Unspecified"] = "UNSPECIFIED";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["Valid"] = "VALID";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["MissingPhysicalColumn"] = "MISSING_PHYSICAL_COLUMN";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["IncompatibleDataType"] = "INCOMPATIBLE_DATA_TYPE";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["NewColumn"] = "NEW_COLUMN";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["PhysicalColumnDataTypeChanged"] = "PHYSICAL_COLUMN_DATA_TYPE_CHANGED";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["PrimaryKeyInfoChanged"] = "PRIMARY_KEY_INFO_CHANGED";
    TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum["SystemPropertiesChanged"] = "SYSTEM_PROPERTIES_CHANGED";
})(TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum = exports.TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum || (exports.TableauPublishedconnectionV1ColumnSyncDetailsStatusEnum = {}));
function TableauPublishedconnectionV1ColumnSyncDetailsFromJSON(json) {
    return TableauPublishedconnectionV1ColumnSyncDetailsFromJSONTyped(json, false);
}
exports.TableauPublishedconnectionV1ColumnSyncDetailsFromJSON = TableauPublishedconnectionV1ColumnSyncDetailsFromJSON;
function TableauPublishedconnectionV1ColumnSyncDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'column': !runtime_1.exists(json, 'column') ? undefined : _1.TableauPublishedconnectionV1ColumnFromJSON(json['column']),
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
    };
}
exports.TableauPublishedconnectionV1ColumnSyncDetailsFromJSONTyped = TableauPublishedconnectionV1ColumnSyncDetailsFromJSONTyped;
function TableauPublishedconnectionV1ColumnSyncDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'column': _1.TableauPublishedconnectionV1ColumnToJSON(value.column),
        'status': value.status,
    };
}
exports.TableauPublishedconnectionV1ColumnSyncDetailsToJSON = TableauPublishedconnectionV1ColumnSyncDetailsToJSON;
